'use client';

import Head from 'next/head';
import { LayoutContainer, PageMainContainer } from '@/components/Layout';
import useRollbarError from '@/hooks/useRollbarError';
import { InternalServerErrorIcon } from '@/icons';

export default function GlobalError({ error }: { error: Error & { digest?: string } }) {
  useRollbarError(error);
  return (
    <html lang='sv'>
      <body>
        <LayoutContainer>
          <PageMainContainer>
            <div className='h-screen'>
              <Head>
                <title>Oväntat serverfel - Booli Pro</title>
              </Head>
              <div className='flex h-full flex-col items-center'>
                <div className='tablet:w-2/3 mobile:w-full mobile:px-6 w-1/2 max-w-7xl'>
                  <h1 className='tablet:text-5xl mobile:text-3xl text-6xl'>Åh nej!</h1>
                  <p className='text-md mobile:text-sm my-4'>
                    Teknik är fantastiskt men ibland fungerar inte allt som planerat. Testa igen om en liten stund. Du
                    kan höra av dig till Booli Pro support om problemet kvarstår.
                  </p>
                  <a
                    href='mailto:pro@booli.se'
                    className='text-bui-color-blue underline'
                  >
                    Maila supporten
                  </a>
                </div>
                <InternalServerErrorIcon className='tablet:h-64 mobile:h-56 h-96' />
              </div>
            </div>
          </PageMainContainer>
        </LayoutContainer>
      </body>
    </html>
  );
}
